import OspRow from './OspRow.vue';

export default OspRow;



// WEBPACK FOOTER //
// ./src/components/OspRow/index.js